<svg width="254" height="259" viewBox="0 0 254 259" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="146.601" cy="106.601" r="106.296" transform="rotate(89.9252 146.601 106.601)" fill="url(#paint0_linear_249_108)"/>
<circle cx="22.6798" cy="235.538" r="20.5818" transform="rotate(-174.257 22.6798 235.538)" fill="url(#paint1_linear_249_108)"/>
<defs>
<linearGradient id="paint0_linear_249_108" x1="146.601" y1="212.897" x2="593.875" y2="-366.485" gradientUnits="userSpaceOnUse">
<stop stop-color="#FDC029"/>
<stop offset="1" stop-color="#F55200"/>
</linearGradient>
<linearGradient id="paint1_linear_249_108" x1="22.6798" y1="256.12" x2="-30.692" y2="177.411" gradientUnits="userSpaceOnUse">
<stop stop-color="#FDC029"/>
<stop offset="1" stop-color="#F55200"/>
</linearGradient>
</defs>
</svg>
